import React from 'react';
import { QUEST_TYPES } from '../../helpers/quests';

const paths = {
  [QUEST_TYPES.UPGRADE]: (
    <path d="M12 19V5m0 0-6 6m6-6 6 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  ),
  [QUEST_TYPES.INVITE]: (
    <>
      <circle cx="9" cy="8" r="4" strokeWidth="2" />
      <path d="M3 20a6 6 0 0 1 12 0M19 8v6m3-3h-6" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  [QUEST_TYPES.INVITE_MULTI]: (
    <>
      <circle cx="8" cy="8" r="3.5" strokeWidth="2" />
      <circle cx="17" cy="9" r="2.5" strokeWidth="2" />
      <path d="M2 20a6 6 0 0 1 12 0M15 14.5a5 5 0 0 1 7 4.5" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  [QUEST_TYPES.HOLD]: (
    <>
      <ellipse cx="12" cy="6" rx="7" ry="3" strokeWidth="2" />
      <path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" strokeWidth="2" />
    </>
  ),
  [QUEST_TYPES.RECYCLE]: (
    <path
      d="M20 11a8 8 0 0 0-14.3-4.9L4 8m0-4v4h4M4 13a8 8 0 0 0 14.3 4.9L20 16m0 4v-4h-4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  [QUEST_TYPES.GOLD_RECYCLE]: (
    <>
      <path d="M12 3v4m0 0-2-2m2 2 2-2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M19 13a7 7 0 1 1-12.6-4.2M17.6 8.8A7 7 0 0 1 19 13"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.5 15.5 12 11l2.5 4.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  [QUEST_TYPES.COMBO]: (
    <>
      <path
        d="M8 21h8m-4-4v4M7 4h10v5a5 5 0 0 1-10 0V4Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17 6h3v1a3 3 0 0 1-3 3M7 6H4v1a3 3 0 0 0 3 3" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  [QUEST_TYPES.GOLD_TEAM]: (
    <>
      <path d="M4 9l3 3 5-6 5 6 3-3-2 10H6L4 9Z" strokeWidth="2" strokeLinejoin="round" />
    </>
  ),
};

export const QuestIcon = ({ type, color = '#985AFF', className = 'w-[2.4rem] h-[2.4rem]' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke={color} xmlns="http://www.w3.org/2000/svg">
    {paths[type] ?? paths[QUEST_TYPES.UPGRADE]}
  </svg>
);
